<template>
  <div>
    <v-row>
      <v-col cols="12" class="">
        <v-row>
          <v-col cols="6" class="pb-0">

            <v-text-field class="input-text-size" label="Fund Number"
            v-uppercase=globalSettingItem.conEverythingToCap
            v-model="editedItem.fundNumber">
            </v-text-field>

          </v-col>
          <v-col cols="4" class="pb-0 mt-4">
           <p>Bank Information</p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Remit Unit"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.remitUnit">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Account Number"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model.number="editedItem.bankAcctNum">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size"
        label="Unit Name"
        v-model="editedItem.name">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Routing Number"
        v-model.number="editedItem.bankRoutingNum">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Contact Person"
        v-model="editedItem.contactPerson">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-select class="input-text-size" label="Account Type">
        </v-select>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <ClarionDateControl
          label="Bond expires"
          v-model="editedItem.bondExpires"
          :isToggle="false"
          :isIsoDate="true"
        />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Address 1"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.address1">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-checkbox class="input-text-size" label="Skip Envelope Printing"
        v-model="editedItem.envelopePrinting">
        </v-checkbox>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Address 2"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.address2">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-checkbox
           class="input-text-size" label="skip Warrant printing"
           v-model="editedItem.warrantPrinting"
          ></v-checkbox>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Address 3"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.address3">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-checkbox
           class="input-text-size" label="ACH/EFT"
           v-model="editedItem.achEft"
          ></v-checkbox>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Email Address"
        v-uppercase=globalSettingItem.conEverythingToCaps
        :rules="emailRules"
        v-model="editedItem.emailAddress">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Email Address 2"
        v-uppercase=globalSettingItem.conEverythingToCaps
        :rules="emailRules"
        v-model="editedItem.emailAddress2">
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Email Address 3"
        v-uppercase=globalSettingItem.conEverythingToCaps
        :rules="emailRules"
        v-model="editedItem.emailAddress3">
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { toIsoDate } from '../../../util/shared/tmc-global';

export default {
  name: 'remitUnitEditedItem',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'remitUnitSharedList',
    },
  },
  components: {
    ClarionDateControl,
  },
  data() {
    return {
      emailRules: [
        (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid email format',
      ],
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'index',
      'items',
      'isVisible',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  created() {
    if (!this.editedItem.bondExpires) {
      this.setItem([this.baseCrudKey, { ...this.editedItem, bondExpires: toIsoDate() }]);
    }
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
